export default "__VITE_ASSET__CQInmY30__"